import { render, staticRenderFns } from "./CategoriaDoColaborador.vue?vue&type=template&id=4805634a&"
import script from "./CategoriaDoColaborador.vue?vue&type=script&lang=js&"
export * from "./CategoriaDoColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports